var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.containerStyles)},[_vm._v(_vm._s(_vm.time_readable))])}
var staticRenderFns = []

export { render, staticRenderFns }